import {TypeLocalNameEnum} from 'domain/usecases';
import {makeGetExamsTypesLocation} from 'main/factories/usecases';
import {GetExamsListParams} from './types';

export async function getExamsList({
	stateCode,
	cityName,
	age,
	gender,
	typeLocalName,
	signal,
}: GetExamsListParams) {
	const examTypes = await makeGetExamsTypesLocation().get({
		stateCode,
		cityName,
		age,
		gender,
		typeLocalName: typeLocalName || TypeLocalNameEnum.CIDADE,
		signal,
	});

	if (!examTypes) {
		return {tiposExames: []};
	}

	return examTypes;
}
